'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _addPromiseTemplate = require('../templates/promise/addPromiseTemplate.html');

var _addPromiseTemplate2 = _interopRequireDefault(_addPromiseTemplate);

var _updateOwnerTemplate = require('../templates/promise/updateOwnerTemplate.html');

var _updateOwnerTemplate2 = _interopRequireDefault(_updateOwnerTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddPromise = function () {
  function AddPromise($uibModal, $rootScope, enums, appConfig, authService, promiseService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AddPromise);
    this.$scope = $rootScope.$new();
    this.$uibModal = $uibModal;
    this.authService = authService;
    this.appConfig = appConfig;

    this.$scope.promiseService = promiseService;
    this.$scope.authService = authService;
    this.$scope.enums = enums;
    this.$scope.categories = this.convertEnumToKeyValueList(enums.PROMISE_CATEGORY, true);
    this.$scope.addPromise = this.addPromise;
    this.$scope.validateForm = this.validateForm;
    this.$scope.checkCurrentTime = this.checkCurrentTime;
    this.$scope.getFullDateTime = this.getFullDateTime;
    this.$scope.contactSelected = this.contactSelected.bind(this.$scope);
    this.$scope.searchContactUrl = appConfig.apiServiceBaseUri + 'api/contact/search/' + authService.authData.currentLocation.key + '/';
    this.$scope.getPromiseFromForm = this.getPromiseFromForm;
    this.$scope.closeModal = this.closeModal;
    this.$scope.addPromiseSuccess = this.addPromiseSuccess;
    this.$scope.searchUsersUrl = appConfig.apiServiceBaseUri + 'api/user/search/' + authService.authData.currentLocation.key + '/';
    this.$scope.initialOwnerName = authService.authData.firstName + ' ' + authService.authData.lastName;
    this.$scope.ownerSelected = this.ownerSelected.bind(this.$scope);
    this.$scope.updateOwner = this.updateOwner;
  }

  (0, _createClass3.default)(AddPromise, [{
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'showAddPromise',
    value: function showAddPromise(successHandler, noSave, noteText, contact, addPromiseConfirmation) {
      this.$scope.searchContactUrl = this.appConfig.apiServiceBaseUri + 'api/contact/search/' + this.authService.authData.currentLocation.key + '/';
      this.$scope.searchUsersUrl = this.appConfig.apiServiceBaseUri + 'api/user/search/' + this.authService.authData.currentLocation.key + '/';

      this.$scope.errMsg = "";
      this.$scope.tempPromise = {
        category: this.$scope.categories[0]
      };
      this.$scope.addPromiseConfirmation = addPromiseConfirmation;

      if (noteText) {
        this.$scope.tempPromise.subject = noteText.substring(0, 200);
      }

      if (contact) {
        this.$scope.tempPromise.category = this.$scope.categories[1];
        this.$scope.tempPromise.contactId = contact.contactId;
        this.$scope.tempPromise.contactName = contact.contactName;
      }

      this.$scope.successHandler = successHandler;
      this.$scope.noSave = noSave;

      this.$scope.datePickerOptions = {
        minDate: new Date(),
        showButtonBar: false
      };

      this.$scope.modalInstance = this.$uibModal.open({
        template: _addPromiseTemplate2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var scope = this;

      if (scope.modalInstance) {
        scope.modalInstance.close();
      }
    }
  }, {
    key: 'addPromise',
    value: function addPromise() {
      var scope = this;

      if (!scope.validateForm()) {
        return;
      }

      var promiseToAdd = scope.getPromiseFromForm();

      if (scope.noSave) {
        scope.addPromiseSuccess(promiseToAdd);
      } else {
        scope.promiseService.addPromise(promiseToAdd).then(function (response) {
          scope.addPromiseSuccess(response.data);
        });
      }
    }
  }, {
    key: 'addPromiseSuccess',
    value: function addPromiseSuccess(promiseToAdd) {
      var scope = this;

      scope.closeModal();

      if (scope.successHandler) {
        scope.successHandler(promiseToAdd);
      }
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      var scope = this;

      if (!scope.tempPromise.subject) {
        scope.errMsg = 'Please enter some text for the subject';
        return false;
      }

      if (!scope.tempPromise.category.id) {
        scope.errMsg = 'Please select a category';
        return false;
      }

      if (scope.tempPromise.category.id === scope.enums.PROMISE_CATEGORY.Customer && !scope.tempPromise.contactId) {
        scope.errMsg = 'Please select a contact';
        return false;
      }

      if (!scope.tempPromise.date) {
        scope.errMsg = 'Please select a due date';
        return false;
      }

      if (!scope.tempPromise.time) {
        scope.errMsg = 'Please select a due time';
        return false;
      }

      if (scope.checkCurrentTime()) {
        scope.errMsg = 'Due Date cannot be in the past';
        return false;
      }

      return true;
    }
  }, {
    key: 'getPromiseFromForm',
    value: function getPromiseFromForm() {
      var scope = this;

      return {
        ownerId: this.tempPromise.ownerId || scope.authService.authData.userId,
        subject: scope.tempPromise.subject,
        category: scope.tempPromise.category.id,
        dueDate: scope.getFullDateTime(),
        contactId: scope.tempPromise.contactId
      };
    }
  }, {
    key: 'getFullDateTime',
    value: function getFullDateTime() {
      var scope = this;

      var dt = scope.tempPromise.date.getFullYear() + '-' + (scope.tempPromise.date.getMonth() + 1) + '-' + scope.tempPromise.date.getDate();
      var time = scope.tempPromise.time.getHours() + ':' + scope.tempPromise.time.getMinutes();

      return dt + ' ' + time;
    }
  }, {
    key: 'checkCurrentTime',
    value: function checkCurrentTime() {
      return new Date(this.getFullDateTime()) < new Date();
    }
  }, {
    key: 'contactSelected',
    value: function contactSelected(item) {
      if (item) {
        this.tempPromise.contactId = item.originalObject.contactId;
      }
    }
  }, {
    key: 'ownerSelected',
    value: function ownerSelected(item) {
      if (item) {
        this.tempPromise.ownerId = item.originalObject.userId;
      }
    }
  }, {
    key: 'showUpdateOwner',
    value: function showUpdateOwner(promiseId, successHandler) {
      this.$scope.tempPromise = {
        ownerId: this.authService.authData.userId
      };
      this.$scope.initialOwnerName = this.authService.authData.firstName + ' ' + this.authService.authData.lastName;

      this.$scope.errMsg = "";
      this.$scope.promiseId = promiseId;
      this.$scope.successHandler = successHandler;

      this.$scope.modalInstance = this.$uibModal.open({
        template: _updateOwnerTemplate2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'updateOwner',
    value: function updateOwner() {
      var scope = this;

      scope.promiseService.updateOwner(scope.promiseId, this.tempPromise.ownerId).then(function (response) {
        scope.addPromiseSuccess();
      });
    }
  }]);
  return AddPromise;
}();

exports.default = AddPromise;


// WEBPACK FOOTER //
// ./client/app/common/services/addPromiseService.js